import { IEntity, IEquatable, IFeatureType } from '../types';
import { isObject } from './typeGuards';

export async function collectFeatureTypes<T extends IEntity = IEntity>(items: T[], ...keys: string[]): Promise<IFeatureType[]> {
  const featureTypes: IFeatureType[] = [];
  if (keys.length > 0) {
    items.forEach(item => {
      keys.forEach((key) => {
        const value = item[key as keyof T] || [];
        const values = Array.isArray(value) ? value : [value];
        values.forEach(value => {
          let featureType = featureTypes.find(x => x.id === key);
          if (!featureType) {
            featureType = {
              id: key,
              schema: 'featureType',
              title: key,
              mode: 'or',
              features: [],
            };
            featureTypes.push(featureType);
          }
          const features = (featureType.features as IFeatureType['features']);
          const option = (isObject(value) ? ({
            ...value,
            title: (value as any).title || (value as any).name || (value as any).label || 'Untitled',
          }) : ({
            id: value,
            title: String(value),
          })) as {
            id: IEquatable;
            title: string;
            count?: number;
            disabled?: boolean;
          };
          if (
            option.id &&
            option.title &&
            features &&
            !features.find(x => x.id === option.id)
          ) {
            features.push(option);
          }
        });
      });
    });
  }
  featureTypes.forEach((featureType) => {
    featureType.features.sort((a, b) => {
      const textA = a.title.toUpperCase();
      const textB = b.title.toUpperCase();
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
  });
  return featureTypes;
}

export async function collectFeatureTypes__<T extends IEntity = IEntity>(items: T[], ...keys: string[]): Promise<IFeatureType[]> {
  const featureTypes: IFeatureType[] = [];
  if (keys.length > 0) {
    items.forEach(item => {
      keys.forEach((key) => {
        const value = item[key as keyof T];
        if (value) {
          let featureType = featureTypes.find(x => x.id === key);
          if (!featureType) {
            featureType = {
              id: key,
              schema: 'featureType',
              title: key,
              mode: 'or',
              features: [],
            };
            featureTypes.push(featureType);
          }
          const features = (featureType.features as IFeatureType['features']);
          if (features && !features.find(x => x.id === value)) {
            features.push({
              id: value as IEquatable,
              title: String(value),
            });
          }
        }
      });
    });
  }
  return featureTypes;
}
